module.exports = __webpack_public_path__ + "img/tractor-chassi.e2e58c83.png";